import { SiteSurvey } from "api/types/siteSurvey";
import { fetchJson, FetchJsonReturnType } from "shared/fetch/fetchJson";

export async function saveSurveyApi(
  survey: SiteSurvey,
  signal: AbortSignal
): Promise<FetchJsonReturnType<SiteSurvey>> {
  return fetchJson<SiteSurvey>("/api/siteSurvey/save", {
    method: "post",
    body: survey,
    signal: signal,
  });
}
